import {autoserializeAs, inheritSerialization} from "dcerialize";
import type {Existing, IdentifiableModel, IdOf} from "../base/IdentifiableModel";
import {createExisting} from "../base/IdentifiableModel";
import type {ModificationTrackedModel} from "../base/ModificationTrackedModel";
import {ModificationDetails} from "../ModificationDetails";

export class IdOnlyIndustrySection implements IdentifiableModel {
  @autoserializeAs(() => Number)
  public id?: number;

  public static existing(id: IdOf<IdOnlyIndustrySection>): Existing<IdOnlyIndustrySection> {
    return createExisting(IdOnlyIndustrySection, id);
  }
}

@inheritSerialization(() => IdOnlyIndustrySection)
export class SimpleIndustrySection extends IdOnlyIndustrySection {
  @autoserializeAs(() => String)
  public readonly name: string;
}

/**
 * @sealed
 */
@inheritSerialization(() => SimpleIndustrySection)
export class IndustrySection extends SimpleIndustrySection implements ModificationTrackedModel {
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;
}

/**
 * @sealed
 */
export class IndustrySectionTranslation implements ModificationTrackedModel {
  @autoserializeAs(() => String)
  public name: string;
  @autoserializeAs(() => ModificationDetails)
  public readonly modificationDetails?: ModificationDetails;

  public static createEmpty(): IndustrySectionTranslation {
    const translation = new IndustrySectionTranslation();
    translation.name = "";
    return translation;
  }
}
